import http from '../interceptors/Intercepter';

export const createQuery = async (username, queryVo) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.post('/api/query/create', queryVo, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const viewAvailableFormsForQuery = async (username, reviewExternalReference) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      reviewExternalReference: reviewExternalReference,
      username: username,
    };

    const { data } = await http.get('/api/query/view/form', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const viewAllQueriesForReview = async (username, reviewExternalReference) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const queryParams = new URLSearchParams({
      reviewExternalReference: reviewExternalReference,
      username: username,
    }).toString();

    const { data } = await http.get(`/api/query/viewAll/review?${queryParams}`, config);

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const viewQuery = async (username, queryExternalReference) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      queryExternalReference: queryExternalReference,
      username: username,
    };

    const { data } = await http.get('/api/query/view', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const updateQuery = async (username, updateQueryRequest) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.put('/api/query/update', updateQueryRequest, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};
